const MESSAGE_SIZE_LIMIT = 25000;

const MAX_ATTACHMENTS = 15;

enum ThreadType {
  PRE_CLOSE = 'preClose',
  POST_CLOSE = 'postClose',
  ALL = 'all'
};

export {
  MESSAGE_SIZE_LIMIT,
  MAX_ATTACHMENTS,
  ThreadType
}
